import {DestroyRef, Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {CurrentRightsService, groupRights} from "@services/current-rights.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {filter, take} from "rxjs";
import {Rights} from "@models/sportexam/rights";

@Directive({
    selector: '[canWatch]'
})
export class CanWatchDirective {
    @Input() set canWatch(group: groupRights|boolean|keyof Rights) {
        if(group === true) {
            this.vc.createEmbeddedView(this.tpl);
            return;
        }
        if(group === false) {
            this.vc.clear();
            return;
        }
        this.currentRights.rights$.pipe(
            filter(Boolean),
            take(1),
            takeUntilDestroyed(this.destoryRef)
        ).subscribe(_ => {
            if (_) {
                // Если это ключ из Rights интерфейса (прямое право)
                if (typeof group === 'string') {
                    if (_[group]) {
                        this.vc.createEmbeddedView(this.tpl);
                    }
                } else {
                    // Если это groupRights (группа прав)
                    const {watch} = this.currentRights.getRightsBy(group)
                    if (watch) {
                        this.vc.createEmbeddedView(this.tpl);
                    }
                }
            }
        })
    }

    constructor(
        private tpl: TemplateRef<any>,
        private vc: ViewContainerRef,
        private currentRights: CurrentRightsService,
        private destoryRef: DestroyRef
    )
    {
    }

}
